import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useStyles } from "./styles";

type BoxLengthRow = {
  id: string;
  parameterKey: string;
  weight: string;
  price: string;
  unitKey: string;
  quantity: string;
  totalWeight: string;
  totalPrice: string;
  totalPriceNis: string;
};

const boxLengthRows: BoxLengthRow[] = [
  {
    id: "1",
    parameterKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.ROWS.FLOOR_3",
    weight: "72",
    price: "$0,85",
    unitKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.UNIT.METER_RUNNING",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "$0",
    totalPriceNis: "₪ 0",
  },
  {
    id: "2",
    parameterKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.ROWS.FLOOR_4",
    weight: "96",
    price: "$0,85",
    unitKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.UNIT.METER_RUNNING",
    quantity: "8,6",
    totalWeight: "825,60",
    totalPrice: "$701,76",
    totalPriceNis: "₪ 2,807.04",
  },
  {
    id: "3",
    parameterKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.ROWS.FLOOR_5",
    weight: "120",
    price: "$0,85",
    unitKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.UNIT.METER_RUNNING",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "$0",
    totalPriceNis: "₪ 0",
  },
  {
    id: "4",
    parameterKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.ROWS.FLOOR_6",
    weight: "144",
    price: "$0,85",
    unitKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.UNIT.METER_RUNNING",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "$0",
    totalPriceNis: "₪ 0",
  },
  {
    id: "5",
    parameterKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.ROWS.ST52_FLOOR_4",
    weight: "96",
    price: "$1",
    unitKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.UNIT.METER_RUNNING",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "$0",
    totalPriceNis: "₪ 0",
  },
  {
    id: "6",
    parameterKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.ROWS.ST52_FLOOR_5",
    weight: "120",
    price: "$1",
    unitKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.UNIT.METER_RUNNING",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "$0",
    totalPriceNis: "₪ 0",
  },
  {
    id: "7",
    parameterKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.ROWS.ROUND_BAR_3",
    weight: "72",
    price: "$1,05",
    unitKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.UNIT.METER_RUNNING",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "$0",
    totalPriceNis: "₪ 0",
  },
  {
    id: "8",
    parameterKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.ROWS.ROUND_BAR_4",
    weight: "96",
    price: "$1,1",
    unitKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.UNIT.METER_RUNNING",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "$0",
    totalPriceNis: "₪ 0",
  },
  {
    id: "9",
    parameterKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.ROWS.ROUND_BAR_5",
    weight: "120",
    price: "$1,1",
    unitKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.UNIT.METER_RUNNING",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "$0",
    totalPriceNis: "₪ 0",
  },
  {
    id: "10",
    parameterKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.ROWS.ROUND_BAR_6",
    weight: "144",
    price: "$1,1",
    unitKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.UNIT.METER_RUNNING",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "$0",
    totalPriceNis: "₪ 0",
  },
  {
    id: "11",
    parameterKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.ROWS.DROP_BAR_3",
    weight: "84",
    price: "$0,9",
    unitKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.UNIT.METER_RUNNING",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "$0",
    totalPriceNis: "₪ 0",
  },
  {
    id: "12",
    parameterKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.ROWS.DROP_BAR_4",
    weight: "108",
    price: "$0,9",
    unitKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.UNIT.METER_RUNNING",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "$0",
    totalPriceNis: "₪ 0",
  },
  {
    id: "13",
    parameterKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.ROWS.DROP_BAR_5",
    weight: "132",
    price: "$0,9",
    unitKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.UNIT.METER_RUNNING",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "$0",
    totalPriceNis: "₪ 0",
  },
  {
    id: "14",
    parameterKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.ROWS.ROUND_DROP_BAR_3",
    weight: "84",
    price: "$1,25",
    unitKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.UNIT.METER_RUNNING",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "$0",
    totalPriceNis: "₪ 0",
  },
  {
    id: "15",
    parameterKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.ROWS.ROUND_DROP_BAR_4",
    weight: "108",
    price: "$1,25",
    unitKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.UNIT.METER_RUNNING",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "$0",
    totalPriceNis: "₪ 0",
  },
  {
    id: "16",
    parameterKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.ROWS.ROUND_DROP_BAR_5",
    weight: "132",
    price: "$1,25",
    unitKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.UNIT.METER_RUNNING",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "$0",
    totalPriceNis: "₪ 0",
  },
  {
    id: "17",
    parameterKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.ROWS.FLOOR_WEIGHT_REDUCTION",
    weight: "90,88",
    price: "$0,85",
    unitKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.UNIT.METER_RUNNING",
    quantity: "8,6",
    totalWeight: "781,57",
    totalPrice: "$7,31",
    totalPriceNis: "₪ 22,51",
  },
  {
    id: "18",
    parameterKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.ROWS.ALUMINUM_FLOOR_PROFILE",
    weight: "4,23",
    price: "₪ 96",
    unitKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.UNIT.METER",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "$0",
    totalPriceNis: "₪ 0",
  },
  {
    id: "19",
    parameterKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.ROWS.ROLLING_STRIP_5",
    weight: "24,4",
    price: "$0,85",
    unitKey: "QUOTES.DETAILS.BOX_LENGTH_PARAMETER.UNIT.METER_RUNNING",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "$0",
    totalPriceNis: "₪ 0",
  },
];

const QuotesBoxLengthParameter = () => {
  const styles = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={styles.root}>
      <Typography className={styles.title}>
        {t("QUOTES.DETAILS.BOX_LENGTH_PARAMETER.TITLE")}
      </Typography>

      <Box className={styles.list}>
        {boxLengthRows.map((row) => (
          <Box className={styles.rowCard} key={row.id}>
            <Box className={styles.parameterCell}>
              <Typography className={styles.fieldLabel}>
                {t("QUOTES.DETAILS.BOX_LENGTH_PARAMETER.PARAMETER")}
              </Typography>

              <Typography className={styles.parameterValue}>
                {t(row.parameterKey)}
              </Typography>
            </Box>

            <Box className={styles.valuesGrid}>
              <Box className={styles.valueCell}>
                <Typography className={styles.fieldLabel}>
                  {t("QUOTES.DETAILS.BOX_LENGTH_PARAMETER.WEIGHT")}
                </Typography>
                <Typography className={styles.fieldValue}>{row.weight}</Typography>
              </Box>

              <Box className={styles.valueCell}>
                <Typography className={styles.fieldLabel}>
                  {t("QUOTES.DETAILS.BOX_LENGTH_PARAMETER.PRICE")}
                </Typography>
                <Typography className={styles.fieldValue}>{row.price}</Typography>
              </Box>

              <Box className={styles.valueCell}>
                <Typography className={styles.fieldLabel}>
                  {t("QUOTES.DETAILS.BOX_LENGTH_PARAMETER.UNIT_LABEL")}
                </Typography>
                <Typography className={styles.fieldValue}>
                  {t(row.unitKey)}
                </Typography>
              </Box>

              <Box className={styles.valueCell}>
                <Typography className={styles.fieldLabel}>
                  {t("QUOTES.DETAILS.BOX_LENGTH_PARAMETER.QUANTITY")}
                </Typography>
                <Typography className={styles.fieldValue}>{row.quantity}</Typography>
              </Box>

              <Box className={styles.valueCell}>
                <Typography className={styles.fieldLabel}>
                  {t("QUOTES.DETAILS.BOX_LENGTH_PARAMETER.TOTAL_WEIGHT")}
                </Typography>
                <Typography className={styles.greenValue}>
                  {row.totalWeight}
                </Typography>
              </Box>

              <Box className={styles.valueCell}>
                <Typography className={styles.fieldLabel}>
                  {t("QUOTES.DETAILS.BOX_LENGTH_PARAMETER.TOTAL_PRICE")}
                </Typography>
                <Typography className={styles.greenValue}>
                  {row.totalPrice}
                </Typography>
              </Box>

              <Box className={styles.valueCell}>
                <Typography className={styles.fieldLabel}>
                  {t("QUOTES.DETAILS.BOX_LENGTH_PARAMETER.TOTAL_PRICE_NIS")}
                </Typography>
                <Typography className={styles.greenValue}>
                  {row.totalPriceNis}
                </Typography>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default QuotesBoxLengthParameter;